import AuthTabsCompnent from "./AuthTabsComponent";

export default AuthTabsCompnent;
